import React from 'react'
import styled from 'styled-components'
import { Collapse } from '@material-ui/core'
import propTypes from 'prop-types'
import menu from './menu'
import Container from '../container'
import { HashLink } from 'react-router-hash-link'

const Int = styled.div`
  height: calc(100vh - 60px);
  box-sizing: border-box;
  padding-top: 30px;
`
const Wrapper = styled.div`
  background: var(--first);
  position: absolute;
  width: 100vw;
  right: 0px;
  top: 60px;
  z-index: 10;
`
const MenuItem = styled(HashLink)`
  text-decoration: none;
  display: block;
  text-align: center;
  font-size: 1.5em;
  margin-top: .5em;
`

const OptionsMobile = props => {
  const handleScroll = element => {
    try {
      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Wrapper onClick={props.onClose}>
      <Collapse in={props.open}>
        <Container>
          <Int>

            {menu.map((menuItem, index) => {
              const props = {}
              if (menuItem.external) props.as = 'a'
              if (menuItem.external) props.href = menuItem.path
              else props.to = menuItem.path
              return (
                <MenuItem key={index} {...props} scroll={handleScroll}>
                  {menuItem.label}
                </MenuItem>
              )
            })}

          </Int>
        </Container>
      </Collapse>
    </Wrapper>
  )
}

OptionsMobile.propTypes = {
  open: propTypes.bool,
  onClose: propTypes.func
}

export default OptionsMobile
